import { render } from "./CreatePublicationAdModal.vue.js?vue&type=template&id=1970486b!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreatePublicationAdModal.vue?vue&type=template&id=1970486b"
import script from "./CreatePublicationAdModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreatePublicationAdModal.vue?vue&type=script&lang=js"
export * from "./CreatePublicationAdModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreatePublicationAdModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/CreatePublicationAdModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1970486b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1970486b', __exports__)) {
    api.reload('1970486b', __exports__)
  }
  
  module.hot.accept("./CreatePublicationAdModal.vue.js?vue&type=template&id=1970486b!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreatePublicationAdModal.vue?vue&type=template&id=1970486b", () => {
    api.rerender('1970486b', render)
  })

}


export default __exports__